// src/components/NavbarAdmin.js
import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import './styles/Navbar.css';

export default function NavbarAdmin() {
  const { user } = useContext(AuthContext);
  const isAdmin = user?.role === "admin" || user?.role === "super-admin" || user?.role === "Manager";
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => setOpen(false), [loc.pathname]); // close on route change

  if (!isAdmin) return null;

  return (
    <div className="flex">
      {/* Mobile toggle button (only shows on small screens) */}
      <button
        className="admin-toggle"
        onClick={() => setOpen(v => !v)}
        aria-expanded={open}
        aria-controls="admin-drawer"
      >
        Admin Menu
      </button>

      {/* Overlay for mobile */}
      <div
        className={`admin-overlay ${open ? "show" : ""}`}
        onClick={() => setOpen(false)}
      />

      {/* Sidebar */}
      <aside id="admin-drawer" className={`admin-sidebar ${open ? "open" : ""}`}>
        <h2>🔒 Admin Menu</h2>
        <ul>
          <li><Link to="/user-manager">Users</Link></li>
          <li><Link to="/trigger-reports">Trigger Reports</Link></li>
          <li><Link to="/regular-sms-viewer">SMS Viewer</Link></li>
          <li><Link to="/site-manager" className="hover:underline">Kiosk Screen</Link></li>
          <li><Link to="/compare-sites-viewer" className="hover:underline">Compare Sites</Link></li>
          <li><Link to="/graph-each-day" className="hover:underline">Graph Each Day</Link></li>
          <li><Link to="/cron-status">Cron Status</Link></li>
          <li><Link to="/transactions" className="hover:underline">Transactions</Link></li>
          <li><Link to="/impact/fnp" className="hover:underline">FNP Water</Link></li>
            
        </ul>
      </aside>
    </div>
  );
}
